<script setup>
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

const copyLink = async () => {
  await copyTextToClipboard(props.url);
  useAlert(t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.QR.PUBLIC_LINK_COPIED'));
};
</script>

<template>
  <div class="flex flex-col items-center gap-1.5 w-full">
    <p class="text-xs text-n-slate-11 text-center">
      {{ t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.QR.PUBLIC_LINK_DESC') }}
    </p>
    <div class="flex items-center gap-2 w-full max-w-xs">
      <input
        :value="url"
        readonly
        class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-n-weak bg-n-solid-1 text-n-slate-11 truncate"
        @focus="$event.target.select()"
      />
      <NextButton
        v-tooltip.top="t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.QR.COPY_LINK')"
        icon="i-lucide-copy"
        faded
        slate
        xs
        @click="copyLink"
      />
    </div>
  </div>
</template>
